<template>
  <el-dialog 
    :title="`修改${fieldLabel}`" 
    :visible.sync="dialogVisible" 
    width="400px" 
    @close="handleClose"
  >
    <el-form :model="form" ref="form" label-width="120px">
      <el-form-item :label="fieldLabel + ':'" prop="value">
        <el-input 
          v-model="form.value" 
          :placeholder="`请输入${fieldLabel}`"
          type="number"
          step="0.01"
        />
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确认修改</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FieldEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    fieldLabel: {
      type: String,
      required: true
    },
    currentValue: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        value: ''
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.form.value = this.currentValue || ''
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    }
  },
  methods: {
    async handleSubmit() {
      this.loading = true
      try {
        // 调用API接口
        const response = await axios.post(this.base_url + '/orders/update_fd', {
          id: this.orderId,
          fd: this.fieldName,
          val: this.form.value
        })
        
        if (response.status === 200 && response.data.code) {
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message.error(response.data.message || '修改失败')
        }
      } catch (error) {
        console.error('修改字段失败:', error)
        this.$message.error('修改失败，请重试')
      } finally {
        this.loading = false
      }
    },
    
    handleClose() {
      this.dialogVisible = false
      this.form.value = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.el-form {
  padding: 20px 0;
}
</style>